<template>
  <div>
    <div v-if="loading" class="text-center py-3">
      <span>Carregando...</span>
    </div>

    <div v-else-if="histories.length > 0" class="history-table">
      <table class="table table-borderless table-border table-align">
        <thead>
          <tr>
            <th>Autor</th>
            <th>Ação</th>
            <th>Criado em</th>
            <th v-for="field in attributesChanged" :key="field">
              {{ fieldLabel(field) }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(history, idx) in histories" :key="idx">
            <td>{{ history._author }}</td>
            <td>{{ history._action }}</td>
            <td>{{ history._created_at | datetime }}</td>
            <td v-for="field in attributesChanged" :key="field">
              <span v-if="field === 'driver_indication_status_id'">
                {{ showStatusName(history[field]) }}
              </span>
              <span v-else>
                {{ history[field] }}
              </span>
            </td>
            <td>
              <button
                class="btn btn-outline btn-sm nowrap"
                @click="toggleJson(idx)"
              >
                {{ showJsonIndex === idx ? 'Ocultar JSON' : 'Ver JSON' }}
              </button>
            </td>
          </tr>
          <tr v-if="showJsonIndex !== null && histories[showJsonIndex]">
            <td colspan="6">
              <Panel :data="rawHistories[showJsonIndex]" :deep="2" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else>
      <p class="text-muted">Nenhum historico disponivel.</p>
    </div>
  </div>
</template>

<script>
import Panel from '@/components/admin/maestro/Panel'

import buildItemHistory from '@/models/buildItemHistory'
import EntityProxy from '@/models/EntityProxy'
import CryptoJS from 'crypto-js'

const md5 = (value) => CryptoJS.MD5(value).toString()
const shortMD5 = (value) => md5(value).slice(0, 4)

export default {
  name: 'DriverIndicationHistories',
  components: { Panel },
  props: {
    indicationId: { required: true },
    driverIndicationStatuses: { required: true, type: Array }
  },
  data: () => ({
    loading: false,
    rawHistories: [],
    showJsonIndex: null
  }),
  created() {
    this.loadHistories()
  },
  computed: {
    histories() {
      if (!this.rawHistories.length === 0) return []
      const data = this.rawHistories
      const histories = EntityProxy.build(buildItemHistory(data.reverse()).reverse())
      return histories.map(h => {
        if (h.metadata) h.metadata = shortMD5(JSON.stringify(h.metadata))
        if (h.credentials) h.credentials = shortMD5(JSON.stringify(h.credentials))

        return h
      })
    },
    attributesChanged() {
      if (!this.rawHistories.length === 0) return []
      return Object.keys(this.histories[0])
        .sort()
        .filter(key => !key.startsWith('_'))
    },
  },
  methods: {
    async loadHistories() {
      this.loading = true
      try {
        const { data } = await this.axios.get(`admin/maestro/driver_indications/${this.indicationId}/histories`)
        this.rawHistories = data
      } catch (e) {
        this.$notify.addError(e)
      } finally {
        this.loading = false
      }
    },
    fieldLabel(field) {
      const labels = {
        protocol: 'Protocolo',
        started_at: 'Início do processo',
        ticket_id: 'ID da multa',
        account_id: 'ID da conta',
        driver_indication_status_id: 'Status'
      }
      return labels[field] || field
    },
    showStatusName(statusId) {
      const status = this.driverIndicationStatuses.find(s => s.id === statusId)
      return status ? `${status.name} (${status.code})` : statusId
    },
    toggleJson(idx) {
      this.showJsonIndex = this.showJsonIndex === idx ? null : idx
    }
  }
}
</script>

<style scoped>
/* Mantem a tabela dentro da grid do modal e habilita scroll horizontal
   apenas dentro da propria tabela de historico quando o conteudo excede a largura. */
.history-table {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}

.history-table > table {
  margin-bottom: 0;
}
</style>
